<template>
  <tbody>
    <tr v-for="(item, i) in items" class="hovereable" :key="item.id" @click="editItemWithEvent($event, item.id)">
      <td class="text-xs-center" width="120">
        <v-avatar
          size="45"
          class="transparent"
        >
          <v-icon large class="k-orange-linear-text">fas fa-at</v-icon>
        </v-avatar>
      </td>
      <td>
        <small>Propietario del email</small>
        {{item.name}}
      </td>
      <td>
        <small>Email de plataforma</small>
        {{item.email}}
      </td>
      <td>
        <small>Email redireccionado</small>
        {{item.forwarding}}
      </td>
      <td>
        <v-chip small :class="{'white--text':true, 'green':item.status === 'activo', 'red':item.status === 'inactivo'}">
          <v-icon small>{{item.status === 'activo' ? 'fas fa-check' : 'fas fa-times'}}</v-icon>
          &nbsp;&nbsp;{{item.status.substr(0, 1).toUpperCase()}}{{item.status.substr(1, 50)}}
        </v-chip>
      </td>
      <td class="text-xs-right">
        <v-menu left offset-x>
          <v-btn color="black" flat icon slot="activator">
            <v-icon small>fas fa-ellipsis-v</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="changeStatus(item.id, item.status === 'activo' ? 'inactivo' : 'activo')">
              <v-list-tile-title>{{item.status === 'activo' ? 'Desactivar' : 'Activar'}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="editItem(item.id)">
              <v-list-tile-title>Editar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="deleteItem(item.id, item.email)">
              <v-list-tile-title>Eliminar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </td>
    </tr>
  </tbody>
</template>

<script>
import EventBus from '@/event-bus';
import dataTableMixin from '@/mixins/dataTableList';

export default {
  mixins: [
    dataTableMixin,
  ],
  methods: {
    changeStatus(id, status) {
      this.axios.patch(`company_emails/${id}`, {
        status,
      }).then(() => {
        EventBus.$emit('update');
      }).catch(() => { });
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/company_email/CompanyEmailList.vue